// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-group.vbt-autcomplete-list::-webkit-scrollbar {\n  display: none; /* Safari and Chrome */\n}\n.list-group.vbt-autcomplete-list {\n  min-width: 220px !important;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
